import { fetchDedupe } from 'fetch-dedupe';

export const getCategoryTypes = async (withValues = false) => {
    const response = await fetchDedupe(`/api/categories?withValues=${Boolean(withValues) ? '1' : '0'}`);

    if (!response.data.success) {
        // new Error("Unexpected response from backend");
        console.error(new Error("Unexpected response from backend"), response.data);
    } else {
        return response.data.data;
    }
}
